<template>
	<div class="wrapper">
		<side-bar :sidebar-links="sidebarLinks" type="sidebar" />

		<div class="main-panel">
			<top-navbar />

			<dashboard-content @click.native="toggleSidebar" />
		</div>
	</div>
</template>

<script>
import jwtDecode from 'jwt-decode';

import { SideBar } from '@/components/UIComponents';
import { displaySidebar } from '@/store/mutation-types';

import TopNavbar from './Dashboard/TheTopNavbar.vue';
import DashboardContent from './Dashboard/TheContent.vue';

export default {
	name: 'DashboardLayout',
	components: {
		TopNavbar,
		DashboardContent,
		SideBar,
	},
	computed: {
		userRoles() {
			try {
				const { currentAppName } = this.$store.state;
				const authDataStorageName = `jwt-${currentAppName}-auth_data`;
				const jwtTokenRaw = localStorage.getItem(authDataStorageName);
				if (!jwtTokenRaw) {
					return [];
				}
				const { accessToken } = JSON.parse(jwtTokenRaw);
				const { role } = jwtDecode(accessToken);

				// Role can be a single string or an array
				return Array.isArray(role) ? role : [role];
			} catch (error) {
				console.error('Error decoding JWT token for roles:', error);
				return [];
			}
		},
		sidebarLinks() {
			let links = this.$getConst('sidebarLinks');

			// Handle eshop-specific filtering
			if (this.$store.state && this.$store.state.currentAppName === 'eshop') {
				const hasDirectSale = this.$store.state[this.$store.state.currentAppName]?.currentUser?.DirectSale === 'True';
				if (!hasDirectSale) {
					links = this.$getConst('sidebarLinksNoDirectSale');
				}
			}

			// Filter by required roles
			return links.filter((link) => {
				// If no roles required, show to everyone
				if (!link.requiredRoles || link.requiredRoles.length === 0) {
					return true;
				}

				// Check if user has at least one required role
				return link.requiredRoles.some((requiredRole) => this.userRoles.includes(requiredRole));
			});
		},
	},
	methods: {
		toggleSidebar() {
			if (this.$store.state.showSidebar) {
				this.$store.commit(displaySidebar, false);
			}
		},
	},
};
</script>

<style lang="scss">
@media screen and (max-width: 768px) {
	.navbar > .container-fluid {
		justify-content: end;
	}
}
</style>
